var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_20_11",
    "data-name": "Component 20 \\u2013 11",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44842",
    "data-name": "Group 44842",
    transform: "translate(44 44) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5380",
    "data-name": "Rectangle 5380",
    fill: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62681",
    "data-name": "Group 62681",
    transform: "translate(34 34) rotate(-180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30883",
    "data-name": "Path 30883",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30884",
    "data-name": "Path 30884",
    d: "M21.543,6.5A31.058,31.058,0,0,1,22,12a31.058,31.058,0,0,1-.457,5.5A2.811,2.811,0,0,1,19.6,19.524C17.9,20,12,20,12,20s-5.893,0-7.605-.476A2.811,2.811,0,0,1,2.457,17.5,31.058,31.058,0,0,1,2,12a31.058,31.058,0,0,1,.457-5.5A2.811,2.811,0,0,1,4.395,4.476C6.107,4,12,4,12,4s5.9,0,7.6.476A2.811,2.811,0,0,1,21.543,6.5ZM10,15.5,16,12,10,8.5Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.fd749e82b1d0c9d092d958a4a9d24fc3.svg";
export { ForwardRef as ReactComponent };